import { SortingBatchType } from '../graphql/sortingBatch';
import { FREEZE_HOURS } from '../constants';
import { BatchRowView, BatchStatus, CreationMethod } from '../types';

/**
 * 真实后端批次 → 列表行视图。发出/接收两个方向共用（字段与方向无关，只是查询源不同）。
 *
 * 「已装包/阶段进度」由数据组（DataWorks）自建自维护，api-server 暂不返回，这里用占位值满足类型要求，
 * BatchTable 本身不渲染这两项。「已创建包牌数/包裹数」是 api-server 实时统计（`SortingBatchType.bagCount`/
 * `parcelCount`，`is_deleted=0` 口径），非 DataWorks 维护，按真实值回填。
 */
export const toRealBatchRowView = (b: SortingBatchType, now: number): BatchRowView => {
    const createdAt = Number(b.createdAt);
    const status = b.status as unknown as BatchStatus;
    const creationMethod: CreationMethod = b.origin === 1 ? 'SORTER' : 'MANUAL';
    // destinationWhsCode 本身已经是完整的 Hub-Whs 两段码（如 "LAX-DC"），不能再拼一次 Hub
    const destination = b.destinationWhsCode || b.destinationHubCode;
    // 停更展示暂时关闭，对齐后端 SortingBatchCompletionApplication 的停更标记停用（同一次改动）；
    // 这里不读后端 isStale（后端也没返回该字段），本来就是前端独立按创建时间计算的展示逻辑
    void now;
    void FREEZE_HOURS;
    const frozenAt = undefined;

    return {
        id: Number(b.id),
        batchNumber: b.batchName,
        destination,
        creationSite: b.fromSortingCode,
        status,
        creationMethod,
        creator: (creationMethod === 'SORTER' ? b.sorterCode : b.creatorName) || '-',
        packedBags: 0,
        createdBags: b.bagCount,
        parcels: b.parcelCount,
        createdAt,
        frozen: frozenAt !== undefined,
        frozenAt,
        progress: { totalBags: 0, stages: [] },
    };
};
